import * as actionTypes from '../../actions/purchaseOrders/actionTypes';

export const initialState = {
  // Transient cross-screen handoff: written by the Awarded Packages "Create PO"
  // button, consumed once by the PO create screen, then cleared.
  prefill: null,
};

const purchaseOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PO_PREFILL:
      return {
        ...state,
        prefill: action.data,
      };
    case actionTypes.CLEAR_PO_PREFILL:
      return {
        ...state,
        prefill: null,
      };
    default:
      return state;
  }
};

export default purchaseOrderReducer;
